export default "/fonts/zenloop-regular-webfont.eot?8126f8e930374dee6d52fd64e656dbad";